import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/settings/llm')({
  beforeLoad: () => {
    throw redirect({ to: '/app/settings/ai', replace: true });
  },
});
